import "../../../../shared/lib/store/createAppApi.js";
import "../../../../shared/lib/store/createAppAsyncThunk.js";
import { createAppSelector } from "../../../../shared/lib/store/createAppSelector.js";
import "../../../../shared/lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../shared/lib/store/hooks/useAppStore.js";
import { selectAllFilterValues } from "./selectAllFilterValues.js";
const selectIsFilterValuesMissing = createAppSelector(selectAllFilterValues, (filterValuesItem) => {
  if (!filterValuesItem.isSuccess) {
    return false;
  }
  return !filterValuesItem.data || !Object.keys(filterValuesItem.data).length;
});
export {
  selectIsFilterValuesMissing
};
